module.exports = __webpack_public_path__ + "img/2.b128b47b.svg";